import React from "react";
import { getString } from "../../index";
import { App } from "../../App";
import css from "./index.module.less";
import Constant from "../../utils/Constant";
import { usePageContext } from "../index";
import QRCode from "qrcode.react";
import { DownloadButton } from "../../components/DownloadButton";
import CommonQuestionModal from "../../components/CommonQuestionModal";

const $st = getString;

export function DownloadPhoneView() {
  const { downloadClickReport } = usePageContext();
  const [modalVisible, setModalVisible] = React.useState(false);

  return (
    <App hideHeader={true}>
      <div className={css.phone_container}>
        {/* Logo */}
        <div className={css.logo_container}>
          <img
            src={require("../../images/pionex.png")}
            alt="logo"
            className={css.logo}
          />
        </div>

        {/* Title */}
        <div className={css.phone_title}>
          {getString("homepage_downloadapp_title")}
        </div>

        {/* QR Code */}
        <div className={css.phone_qrcode_container}>
          <QRCode
            value={`https://download.pionex.com/${window.location.search}${window.location.search ? "&from=qr" : "?from=qr"}`}
            size={154}
          />
          <span className={css.qrcode_desc}>{$st("scan_qr_download")}</span>
        </div>

        {/* iOS Section */}
        <div className={css.phone_section}>
          <p className={css.section_title}>iOS</p>
          <div className={css.phone_button_row}>
            <DownloadButton
              icon={require("../../images/ic_appstore.png")}
              title={$st("down_from")}
              desc={"App Store"}
              url={$st("appstore_url")}
              onClick={() => downloadClickReport("app_store_btn")}
            />
            <DownloadButton
              icon={require("../../images/icon_test_flight.svg")}
              title={$st("down_from")}
              desc={"TestFlight"}
              url={$st("testflight_url")}
              onClick={() => downloadClickReport("testflight_btn")}
              invert
            />
          </div>
        </div>

        {/* Android Section */}
        <div className={css.phone_section}>
          <p className={css.section_title}>Android</p>
          <div className={css.phone_button_row}>
            <DownloadButton
              icon={require("../../images/ic_googleplay.png")}
              title={$st("down_from")}
              desc={"Google Play"}
              url={$st("gp_url")}
              onClick={() => downloadClickReport("google_play")}
            />
            <DownloadButton
              icon={require("../../images/ic_apk2.png")}
              title={$st("down_apk")}
              desc={"Android"}
              url={"https://static.pionex.com/apk/pionex.apk"}
              onClick={() => downloadClickReport("apk")}
            />
          </div>
          <div className={css.phone_button_row}>
            <DownloadButton
              icon={require("../../images/icon_samsung_store.svg")}
              title={$st("down_from")}
              desc={"Samsung Store"}
              url={$st("samsung_store_url")}
              onClick={() => downloadClickReport("samsung_store")}
            />
          </div>
        </div>

        {/* Help Link */}
        <div className={css.help_link}>
          <span style={{ color: "#666" }}>
            {getString("download_item_question") + " "}
          </span>
          <span
            onClick={() => {
              downloadClickReport("guide");
              setModalVisible(true);
            }}
            style={{ color: "#2C75FF", cursor: "pointer" }}
          >
            {getString("download_item_click_tip")}
          </span>
        </div>

        <CommonQuestionModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          modalHeight={600}
        />
      </div>
    </App>
  );
}
